import gql from "graphql-tag";

export default gql`
	mutation updateGuarantee($user_id: ID!, $guarantee: Int!) {
		updateGuarantee(userId: $user_id, guarantee: $guarantee) {
			success
		}
	}
`;
